const machine_txt = {
    type: "VA-1790",
    name: "HIGH SPEED COMPUTERIZED BUTTONHOLING SEWING MACHINE",
    description: [
        "Adopt high-precision stepper motor control systems Realize intelligent operation The mechanisms of cloth feeding, needle swing, upper thread cutting, lower thread cutting, cutter and presser foot lifting are all electronically controlled. The feeding, presser foot lifting, needle swing and cutter motors adopt closed-loop motors, which are fast and real-time controlled. adopts amotor-driven cutter, which is more stable than the previous electromagnet driven cutter structure and has lower noise and vibration during cutting",
        "Perfect operation plat form Special groove design increase efficiency of sewing vertical hole,Can sewing even when machine head across position. At the same time by the install extra plat increase cloth put place",
        "Achieve 4200rpm maximum speed, increase working efficiency Adopt direct drive structure, achieve 4200rpm maximum speed. By the means improve the strength & wear resistance of thread take -up lever parts,trimmer for face and bobbin thread and speed of auto foot lifter, highly increase the working efficiency.",
        "Common Specifications",
        "Maximum sewing speed of 4,200 RPM for enhanced productivity",
        "Short thread ends on buttonhole stitching eliminate secondary trimming",
        "Advanced closed-loop control system, easy operation	",
        "Intelligent multiple knife dropping function,No frequent cutter replacement required",
        "Multifunctional color LCD touch screen operation panel",
        "There are many built-in patterns, which can be customized",
        "With basting sewing and joint close combination key function",
        "Upper thread tension controlled in real time by computer for perfect stitch appearance",
        "Oil-free machine head design with tiny oil supply for rotating shuttle",
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/13/machine_img/1.jpg",
    ],
    machine_other_img:[
        "/assets/machine/13/machine_other/1.png",
        "/assets/machine/13/machine_other/2.png",
    ]
}
export default {machine_txt}